import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { IRestChat, TChatId } from 'app/types/rest/IRestChat';
import { getByIdRest } from 'app/rest/effects/chats/chat/api/getByIdRest';
import { updateStoreChat } from 'app/rest/effects/chats/chat/updateStoreChat';
import { TStatus } from 'app/types/model';
import { chatDeleteAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatDeleteAction';
import { sendAuthUserRealTimeStoreAction } from 'app/view/react_components/base/helpers/realTimeHelperTS';

//TODO done
/***
 * загружаем инфу о чате , даже если он удален. Обновляем стор
 * @param id
 * @param isRealtime
 */
export const loadChat = (
    id: TChatId,
    isRealtime: boolean = false
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getByIdRest(id))
            .then((chat: IRestChat)=>{
                if (chat.status === TStatus.STATUS_DELETED){
                    let action = chatDeleteAction(chat);
                    if (isRealtime) {
                        dispatch(sendAuthUserRealTimeStoreAction(action));
                    }
                    return  dispatch(action);
                }
                return dispatch(updateStoreChat(chat,isRealtime));
            })
    };
    return action;
};
